const values = [
  "active_point",
  "awaken",
  "awaken01",
  "boss",
  "damage_dealt",
  "dark",
  "ecoin",
  "event_coop_key",
  "event_dark_key",
  "event_dark_token",
  "event_key",
  "event_light_key",
  "event_light_token",
  "event_nature_key",
  "event_nature_token",
  "event_npe_point",
  "event_physic_key",
  "event_physic_token",
  "event_token",
  "event_water_key",
  "event_water_token",
  "evt_merfolkfighter_goldenegg",
  "evt_turkeyhunt_drumstick",
  "evt_wintergift_giftbox",
  "exp",
  "fire",
  "flying",
  "gears",
  "gem",
  "gold",
  "guild_boss_key",
  "guild_token",
  "guild_trophy",
  "heart",
  "icon_mine_key",
  "light",
  "nature",
  "nonperfect",
  "perfect",
  "perfect_shield",
  "physical",
  "premium_token",
  "question",
  "skin_token",
  "star",
  "stealth",
  "tournament_key",
  "tournament_token",
  "water",
  "event_fire_key",
  "event_fire_token",
  "event_physical_token",
  "icon_event_physical_key",
  "gold_crown",
  "silver_crown",
  "power_scroll",
];
export default values;
